import { useEffect, useState } from "react";

export default function ThemeToggle() {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const [isToggling, setIsToggling] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    const initialTheme = savedTheme || "light";
    setTheme(initialTheme);
    document.documentElement.setAttribute("data-bs-theme", initialTheme);
  }, []);

  const toggleTheme = () => {
    if (isToggling) return;
    setIsToggling(true);

    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-bs-theme", newTheme);

    setTimeout(() => setIsToggling(false), 300);
  };

  return (
    <span className="d-inline-block">
      <button
        id="themeToggle"
        onClick={toggleTheme}
        disabled={isToggling}
        className="btn btn-link p-0 border-0 lh-1"
        aria-label="Toggle theme"
      >
        <i className="bi bi-moon-stars-fill fs-4 align-middle" />
      </button>
    </span>
  );
}
